<template>
    <div :id="siteDisplay" v-cloak>
        <vue-headful :head="{'link[rel=icon]': {href: faviconURL}}"/>
        <router-view :key="$route.fullPath" :name="template"/>
    </div>
</template>

<script>
/* 
* Import libs and componnents
*/
import SiteConstants from 'assets/const/SiteConstants.json';
import EventBus from 'assets/js/eventBus';
import $ from 'jquery';
import 'assets/css/icon.css';

export default {
    /* 
    * Name of component
    */
    name: "template2",
    /* 
    * Declare props
    */
    props: {
        template: String,
    },
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            isLogin: false,
            site: "",
            siteDisplay: "",
            faviconURL: "/favicon.ico"
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        var _faviconURL = "";
        var _cssURL = "";
        var _cssFolderName = "";
        var _jsURL = "";
        var _jsFolderName = "";
        var _latest = Math.random();

        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.$i18n.locale = _this.site;

        var url = location.href.replace("5500","4000").split("/");
        if (process.env.NODE_ENV != 'development'){
            url = location.href.split("/");
        }
        _cssURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('css.url.develop') : _this.$i18n.t('css.url.production');
        if(_cssURL != undefined) {
            _cssURL = url[0]+"//"+url[2]+"/"+_cssURL;
            _cssFolderName = _this.$i18n.t('css.name');
            _this.siteDisplay = _cssFolderName;

            if (!_cssURL.endsWith('/')) {
                _cssURL += '/';
            }
            $('head').append($('<link type="text/css" rel="stylesheet">').attr('href',_cssURL + _cssFolderName + 'style.css?t=' + _latest));
        }

        _jsURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('js.url.develop') : _this.$i18n.t('js.url.production');
        if(_jsURL != undefined) {
            _jsURL = url[0]+"//"+url[2]+"/"+_jsURL;
            _jsFolderName = _this.$i18n.t('js.name');
            if (!_jsURL.endsWith('/')) {
                _jsURL += '/';
            }
            $('head').append($('<script>').attr('type','text/javascript').attr('src',_jsURL + _jsFolderName + 'ninusi.js?t=' + _latest));
        }

        _faviconURL = (process.env.NODE_ENV === 'development') ? _this.$i18n.t('favicon.develop') : _this.$i18n.t('favicon.production');
        if(_faviconURL != undefined) {
            _faviconURL = url[0]+"//"+url[2]+"/"+_faviconURL;
            if (!_faviconURL.endsWith('/')) {
                _faviconURL += '/';
            }
            _this.faviconURL = _faviconURL + "favicon.ico";
        }

        $(function(){
            var ua = navigator.userAgent;
            if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
                $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
            } else {
                $('head').prepend('<meta name="viewport" content="width=1050">');
            }
        });

        EventBus.$on('error-httpStatus', function (httpStatus) {
            if (httpStatus.status == 401 && httpStatus.errorCode == 'ec001') {
                // セッション切れ
                _this.$router.push( {name: 'SessionError', params: { messageError: httpStatus.message ,seconds: httpStatus.path}} );
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec002') {
                // メンテナンス
                _this.$router.push( {name: 'Mente', params: { messageError: httpStatus.message }} );
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec003') {
                // アクセス制限
                _this.$router.push( {name: 'LimitUserAccess',  params: { messageError: httpStatus.message } });
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec018') {
                // ログイン画面へ
                _this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 18}});
            } else if (httpStatus.status == 401 && httpStatus.errorCode == 'ec073') {
                // BtoBログイン画面へ
                _this.$router.push({ name: SiteConstants.PG010MAIN, query: { pageNo: 18}});
            } else if (httpStatus.status == 404) {
                // Forward to 404
                _this.$router.push({ name: 'NotFound'});
            }  else {
                // エラーページへ
                _this.$router.push( {name: 'ErrorPage'} );
            }
        });
    }
}
</script>
